import { Base } from './Base'

export class Permission extends Base {
  scope: string = ''
  action: string = ''
  description: string = ''
}
